import React, { Component } from 'react'
import styled from 'styled-components'
import { StyledImage, Icon, BackgroundImage } from '../components'
import { DOWNLOAD_URL } from '../constants'
import Cookies from 'js-cookie'
const HeaderContent = styled.div`
  padding: 80px 16px 0 16px;
  background: #078489;
  display: flex;
  justify-content: space-between;
  position: relative;
  span {
    position: absolute;
    right: 16px;
  }
`
const IconWrap = styled.div`
  width: 124px;
  height: 124px;
  border-radius: 50%;
  /* border: 1px solid #fff; */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  margin-bottom: -10px;
  background: #fff;
  position: relative;
  overflow: hidden;
  & > img:nth-child(2) {
    max-width: ${props => (props.icons ? '50%' : '100%')};
    height: ${props => (props.icons ? '50%' : '100%')};
    width: auto;
    object-fit: cover;
    border-radius: 0;
    margin: 0 auto;
    position: relative;
  }
  ${props =>
    props.icons &&
    `
     & > img:nth-child(1) {
        opacity:0
     }
  `};
`
const EditWrapper = styled.div`
  border: 2px solid #078489;
  position: absolute;
  right: calc(50% - 68px);
  top: 160px;
  width: 28px;
  height: 28px;
  background-color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > input {
    opacity: 0;
    width: 28px;
    height: 28px;
    position: relative;
    z-index: 999;
  }
  & > span {
    display: inline-flex;
    position: absolute;
    right: 3px;
    top: 3px;
  }
`

class UserContent extends Component {
  state = {}
  render() {
    const { editProfile, onTouch, onPhotoChange, ...props } = this.props
    return (
      <HeaderContent {...props}>
        <IconWrap
          icons={Cookies.getJSON('userDetails').profileImage ? false : true}
          onClick={() => (onPhotoChange ? onPhotoChange() : null)}>
          <BackgroundImage
            src={
              Cookies.getJSON('userDetails').profileImage
                ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                : require('../static/svgs/user.svg')
            }
            alt="profile_img"
          />
          <StyledImage
            height="60px"
            width="60px"
            src={
              Cookies.getJSON('userDetails').profileImage
                ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                : require('../static/svgs/user.svg')
            }
            alt="profile_img"
          />
        </IconWrap>
        {editProfile ? (
          <EditWrapper onClick={() => (onPhotoChange ? onPhotoChange() : null)}>
            {/* <input
              accept="image/*"
              name="newImage"
              type="file"
              onChange={e => (onPhotoChange ? onPhotoChange(e.target.files[0]) : null)}
            /> */}
            <span>
              <Icon icon="edit" color="#078489" />
            </span>
          </EditWrapper>
        ) : (
          <span onClick={() => (onTouch ? onTouch() : null)}>
            <Icon icon="edit" />
          </span>
        )}
      </HeaderContent>
    )
  }
}

export default UserContent



// WEBPACK FOOTER //
// ./src/components/UserContent.js